import { ETelemetryMessageType } from '../enums/ETelemetryPacketType'
import { IBatteryLevels } from '../interfaces/IBatteryLevels'
import { IChamberInjectorPressures } from '../interfaces/IChamberInjectorPressures'
import { ICurrentState } from '../interfaces/ICurrentState'
import { ITankPressures } from '../interfaces/ITankPressures'

export function parsePacketMessageByType(
    type: ETelemetryMessageType,
    message: string,
): IBatteryLevels | ITankPressures | IChamberInjectorPressures | ICurrentState | Record<string, never> {
    switch (type) {
        case ETelemetryMessageType.batteryLevels:
            return parseBatteryLevels(message)
        case ETelemetryMessageType.tankPressures:
            return parseTankPressures(message)
        case ETelemetryMessageType.chamberInjectorPressures:
            return parseChamberInjectionPressures(message)
        case ETelemetryMessageType.currentState:
            return parseCurrentState(message)
        case ETelemetryMessageType.valveStates:
            return parseValveStates(message)
        case ETelemetryMessageType.response:
            return parseValveResponse(message)
        case ETelemetryMessageType.armedStatus:
            return parseValveResponse(message)
        default:
            return {}
    }
}

function parseBatteryLevels(message: string): IBatteryLevels {
    const regex = /Batt(\d): (\d+.\d+) V/g
    const matches = [...message.matchAll(regex)]
    const levels = matches.map((match) => ({
        battery: match[1],
        voltage: match[2],
    }))

    return {
        battery1: parseFloat(levels[0].voltage),
        battery2: parseFloat(levels[1].voltage),
        battery3: parseFloat(levels[2].voltage),
        battery4: parseFloat(levels[3].voltage),
    }
}

function parseTankPressures(message: string): ITankPressures {
    const regex = /DPR tank: {2}(\d+.\d+) bar\nFuel tank: (\d+.\d+) bar\nLOX tank: {2}(\d+.\d+) bar/g

    const [matches] = message.matchAll(regex)
    return {
        DPR: parseFloat(matches[1]),
        fuel: parseFloat(matches[2]),
        LOX: parseFloat(matches[3]),
    }
}

function parseChamberInjectionPressures(message: string): IChamberInjectorPressures {
    const regex = /Chamber: (\d+.\d+) bar\nFuel inj.: (\d+.\d+) bar\nLOX inj.: (\d+.\d+) bar/g

    const [matches] = message.matchAll(regex)
    return {
        chamber: parseFloat(matches[1]),
        fuel: parseFloat(matches[2]),
        LOX: parseFloat(matches[3]),
    }
}

function parseCurrentState(message: string): ICurrentState {
    const messages = message.split('\n')
    const stateMessage = messages.find((message) => message.includes('State:'))
    const substateMessage = messages.find((message) => message.includes('Substate:'))
    const LOXMessage = messages.find((message) => message.includes('LOX level:'))

    const state = stateMessage?.split(':')[1].trim() || 'N/A'
    const substate = substateMessage?.split(':')[1].trim() || 'N/A'
    const LOX = LOXMessage?.split(':')[1].trim()

    return {
        state,
        substate,
        LOX: LOX ? parseFloat(LOX) : undefined,
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseValveStates(message: string) {
    return {}
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseValveResponse(message: string) {
    return {}
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseArmedStatus(message: string) {
    return {}
}
